import { AutoReportPostConfig, BUSINESS_PAYMENT_PREFIX } from '@oy/types';
import axios from 'src/clients/axios';

export const AUTO_REPORT_POST_CONFIG_URL = `${BUSINESS_PAYMENT_PREFIX}/auto-report/product/config`;

export const autoReportPostConfig = (data: AutoReportPostConfig) => {
  return axios.post(AUTO_REPORT_POST_CONFIG_URL, data);
};
